import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { HotToastService } from '@ngneat/hot-toast';

import { BusinessAccountTypeNameMapping, CountryDto, RegionDto } from 'src/app/core/dtos/dto';
import { ConfigHelper } from 'src/app/core/services/helpers/config.helper';
import { CountryRegionService } from 'src/app/core/services/country-region.service';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { selectParentTermName } from 'src/app/state/my-account.selectors';
import { BrandEnum } from 'src/app/core/dtos/enum';

@Component({
  selector: 'app-business-account-form',
  templateUrl: './business-account-form.component.html',
  styleUrls: ['./business-account-form.component.scss']
})
export class BusinessAccountFormComponent implements OnInit {

  @Input() countries: CountryDto;
  @Input() formGroup: FormGroup;
  @Input() isBusinessAccountEditable: boolean;
  @Input() submitted: boolean;

  namePattern = '[\\u0000-\\u007f]+';

  businessAccountTypeNameMapping: BusinessAccountTypeNameMapping;
  brandId: BrandEnum;
  regions: RegionDto[] = [];
  selectParentTermName$: Observable<string>;

  get f() { return this.formGroup.controls; }

  constructor(
    private configHelper: ConfigHelper,
    private formBuilder: FormBuilder,
    private countryService: CountryRegionService,
    private toastService: HotToastService,
    private store: Store,
  ) { }

  ngOnInit(): void {
    this.selectParentTermName$ = this.store.pipe(select(selectParentTermName));
    this.brandId = this.configHelper.getBrandId();
    this.createForm();
    this.getRegions(this.formGroup.controls.countryId.value);
  }

  createForm() {
    if (!this.formGroup) {
      this.formGroup = this.formBuilder.group({
        companyName: ['', Validators.required],
        industry: [''],
        contactFirstName: ['', [Validators.required, Validators.pattern(this.namePattern)]],
        contactLastName: ['', [Validators.required, Validators.pattern(this.namePattern)]],
        salutation: [''],
        email: [''],
        phone: ['', [Validators.required, Validators.pattern("^[0-9]*$")]],
        countryId: [38],
        addressLine1: [''],
        addressLine2: [''],
        city: [''],
        postalCode: [''],
        region: [''],
      });
    }
    if (!this.isBusinessAccountEditable) {
      this.formGroup.disable();
    }

  }

  getRegions(countryId: number) {
    if (countryId) {
      this.countryService.getRegions(countryId)
        .subscribe(
          result => {
            this.regions = result.content;
          },
          (error: HttpErrorResponse) => {
            if (error.status !== 401) {
              this.toastService.warning("Unable to load regions.");
            }
          });
    }
  }
}
